module.exports = __webpack_public_path__ + "static/media/quill.f65b85ff.svg";